import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'
import * as actions from './actions'
import {
  BOOTSTRAP_USER,
  GET_PRESENCE_STATE_ON_INTERVAL,
  CANCEL_PRESENCE_INTERVAL,
  SEND_ACTIVE_STATUS
} from './constants'
import { getQuery } from './selectors'
import * as ConversationSelectors from 'app/modules/conversation/selectors'
import { API } from './api'

const setPresenceInterval = (action$, { getState }) => {
  return action$.ofType(GET_PRESENCE_STATE_ON_INTERVAL).switchMap(action => {
    const interval = action.payload
    return Observable.timer(0, interval)
      .takeUntil(action$.ofType(CANCEL_PRESENCE_INTERVAL))
      .mergeMap(() => {
        return API.getPresenceState(getQuery(getState()))
          .mergeMap(data => {
            return Observable.of(actions.setNewLiveUsers(data))
          })
          .catch(() => Observable.empty())
      })
  })
}

const bootstrapUserEpic = action$ => {
  return action$.ofType(BOOTSTRAP_USER).switchMap(action => {
    return API.bootstrapUser(action.payload)
      .map(actions.bootstrapUserSuccess)
      .catch(() => Observable.of(actions.bootstrapUserError))
  })
}

const sendActiveStatusEpic = (action$, { getState }) => {
  const isActive$ = action$
    .ofType(SEND_ACTIVE_STATUS)
    .pluck('payload')
    .filter(({ isActive }) => !!isActive)

  const isIdle$ = action$
    .ofType(SEND_ACTIVE_STATUS)
    .pluck('payload')
    .filter(({ isActive }) => !isActive)

  return isActive$.switchMap(() => {
    return Observable.timer(0, 20000)
      .mergeMap(() => {
        return API.sendActiveStatus(ConversationSelectors.activeConversationId(getState()))
          .mergeMap(() => Observable.empty())
          .catch(() => Observable.empty())
      })
      .takeUntil(isIdle$)
  })
}

export default combineEpics(setPresenceInterval, bootstrapUserEpic, sendActiveStatusEpic)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/presence/epic.js